import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
const ClientCrudTableRowModal = ({el, i,vinculedLine}) => {
    let {/* code,  documentClient, */ number, type/* , _id */} = el;
    const handleChangeSelect = () => {
        vinculedLine(number, el);
    }

    return (
        <tr>
            <th scope="row">{i + 1}</th>
            <td className="text-center">{number}</td>
            <td className="text-center">{type}</td>
            <td className="text-center">
                <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip-top">Vincular Línea</Tooltip>}>
                    <button type="button" 
                            className="btn btn-sm btn-info me-2"
                            onClick={handleChangeSelect}>
                        <i className="bi bi-pin-angle-fill"/>
                    </button>
                </OverlayTrigger>
            </td>
        </tr>
    );
}
export default ClientCrudTableRowModal;
